module.exports = __webpack_public_path__ + "static/media/s9.4c6c337a.jpg";